/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssociateFilesWithApplicationFormRequest
 */
export interface AssociateFilesWithApplicationFormRequest {
    /**
     * List of file IDs to associate with this application form
     * @type {Array<string>}
     * @memberof AssociateFilesWithApplicationFormRequest
     */
    fileIds: Array<string>;
}

/**
 * Check if a given object implements the AssociateFilesWithApplicationFormRequest interface.
 */
export function instanceOfAssociateFilesWithApplicationFormRequest(value: object): value is AssociateFilesWithApplicationFormRequest {
    if (!('fileIds' in value) || value['fileIds'] === undefined) return false;
    return true;
}

export function AssociateFilesWithApplicationFormRequestFromJSON(json: any): AssociateFilesWithApplicationFormRequest {
    return AssociateFilesWithApplicationFormRequestFromJSONTyped(json, false);
}

export function AssociateFilesWithApplicationFormRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssociateFilesWithApplicationFormRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'fileIds': json['fileIds'],
    };
}

export function AssociateFilesWithApplicationFormRequestToJSON(json: any): AssociateFilesWithApplicationFormRequest {
    return AssociateFilesWithApplicationFormRequestToJSONTyped(json, false);
}

export function AssociateFilesWithApplicationFormRequestToJSONTyped(value?: AssociateFilesWithApplicationFormRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fileIds': value['fileIds'],
    };
}

